module.exports = __webpack_public_path__ + "static/img/fanctions.84fe42c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/fanctions.png
// module id = CC6z
// module chunks = 1